window.Products.HomeDecor.Tablecloth = function () {}
window.Products.HomeDecor.Tablecloth.inherits(window.Products.HomeDecor.HomeDecor)